import React from 'react';
import { tv } from 'tailwind-variants';
import type { SectionStatus } from '../../utils/sectionStatus';
import { useUIText } from '../../hooks/useUIText';
import useDictionary from 'lib/hooks/useDictionary';

interface SectionHeaderProps {
  title: string;
  status?: SectionStatus;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ title, status }) => {
  const { getStatusText } = useUIText();
  const { getDictionaryValue } = useDictionary();

  const getStatusStyles = (status?: SectionStatus) => {
    switch (status) {
      case getDictionaryValue('Complete', 'Complete'):
        return 'bg-color-green-100 border-color-green-600';
      case getDictionaryValue('InProgress', 'In Progress'):
        return 'bg-color-orange-100 border-color-orange-400';
      case getDictionaryValue('ToDo', 'TO DO'):
        return 'bg-color-core-color-4-skyblue-lightTint border-color-core-color-4-skyblue-darkTint';
      default:
        return 'bg-color-core-color-4-skyblue-lightTint border-color-core-color-4-skyblue-darkTint';
    }
  };

  const { container, title: titleClass, statusBadge } = TAILWIND_VARIANTS();
  const statusBadgeClasses = status ? `${statusBadge()} ${getStatusStyles(status)}` : statusBadge();

  const statusText = status ? getStatusText(status.toLowerCase().replace(' ', ''), status) : status;

  return (
    <div className={container()}>
      <h2 className={titleClass()}>{title}</h2>
      {status && <span className={statusBadgeClasses}>{statusText}</span>}
    </div>
  );
};

const TAILWIND_VARIANTS = tv({
  slots: {
    container: ['flex', 'flex-row', 'items-center', 'justify-between', 'gap-spacing-spacing-8'],
    title: [
      'font-typography-font-family-header',
      'text-component-section-title',
      'text-typography-font-size-medium',
      'leading-typography-line-height-medium',
    ],
    statusBadge: [
      'shrink-0',
      'px-padding-micro',
      'rounded-border-radius-radius-1',
      'border',
      'font-typography-font-family-body',
      'text-typography-font-size-body-small',
      'leading-[150%]',
      'text-color-text-dark',
      'font-bold',
      'uppercase',
    ],
  },
});
